export class MockEntityCollectionServiceElementsFactory {
  create = jasmine.createSpy('create').and.returnValue({
    getByKey: () => {},
    dispatcher: {},
    selectors$: {}
  });
}
